var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SectionTransformTable', [_c('SearchList', {
    attrs: {
      "title": _vm.$t('ar_client_list_distribution')
    },
    on: {
      "search": _vm.refetchData
    }
  }, [_c('FormItems', {
    attrs: {
      "formData": _vm.searchVal,
      "items": _vm.formItems
    },
    on: {
      "update:formData": function ($event) {
        _vm.searchVal = $event;
      },
      "update:form-data": function ($event) {
        _vm.searchVal = $event;
      }
    }
  })], 1), _c('b-card', [_c('EzTable', {
    ref: "tableRef",
    attrs: {
      "loading": _vm.loading,
      "excelExportApiCode": "AR_RPD03",
      "excelExport": _vm.arClient.api_ExcelAR_RPD01,
      "columns": _vm.columns,
      "dataSourceParams": {
        Ar_Distributions: _vm.searchVal
      },
      "dataSource": _vm.arClient.api_AR_RPD01,
      "actions": _vm.actions
    },
    on: {
      "action-1": _vm.viewDetailItem,
      "action-2": function (data) {
        return _vm.removeItem(data.data.Id);
      }
    }
  }), _c('SideBarviewDetailsDis', {
    attrs: {
      "detailRowIndex": _vm.detailRowIndex,
      "ListDistributionHistory": _vm.distributionHistory,
      "isShow": _vm.isShowViewDetail,
      "data": _vm.dataDetail
    },
    on: {
      "update:isShow": function ($event) {
        _vm.isShowViewDetail = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowViewDetail = $event;
      },
      "fetch-list": _vm.refetchData,
      "fetch-detail": _vm.viewDetailItem
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }